// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.externaltour.RentalManagerUserPropertyExternalTourWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyExternalTourWebApiHandler_addExternalTourForListing,
  RentalManagerUserPropertyExternalTourWebApiHandler_addExternalTourForModel,
  RentalManagerUserPropertyExternalTourWebApiHandler_removeExternalTourFromListing,
  RentalManagerUserPropertyExternalTourWebApiHandler_removeExternalTourFromModel,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  ListingAlias,
  UserPropertyExternalTourAddForListingRequestWebDto,
  UserPropertyExternalTourAddForListingResponseWebDto,
  UserPropertyExternalTourAddForModelRequestWebDto,
  UserPropertyExternalTourAddForModelResponseWebDto,
  UserPropertyExternalTourRemoveFromListingRequestWebDto,
  UserPropertyExternalTourRemoveFromModelRequestWebDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface AddExternalTourForListingParams {
  listingAlias: ListingAlias;
}
interface AddExternalTourForModelParams {
  encodedFloorplanKey: string;
  listingAlias: ListingAlias;
}
interface RemoveExternalTourFromListingParams {
  listingAlias: ListingAlias;
}
interface RemoveExternalTourFromModelParams {
  encodedFloorplanKey: string;
  listingAlias: ListingAlias;
}

export interface RentalManagerUserPropertyExternalTourWebApiHandler_addExternalTourForListing_Args {
  getParams: AddExternalTourForListingParams;
  postData: UserPropertyExternalTourAddForListingRequestWebDto;
}

export type RentalManagerUserPropertyExternalTourWebApiHandler_addExternalTourForListing_Options = UseMutationOptions<
  UserPropertyExternalTourAddForListingResponseWebDto,
  unknown,
  RentalManagerUserPropertyExternalTourWebApiHandler_addExternalTourForListing_Args
>;

/**
 * Associate an external tour to a building/listing
 */
export const useRentalManagerUserPropertyExternalTourWebApiHandler_addExternalTourForListing = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyExternalTourWebApiHandler_addExternalTourForListing_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyExternalTourWebApiHandler_addExternalTourForListing_Args) =>
      RentalManagerUserPropertyExternalTourWebApiHandler_addExternalTourForListing(
        args.getParams,
        args.postData,
        httpClient,
      ),
  });
};

export interface RentalManagerUserPropertyExternalTourWebApiHandler_addExternalTourForModel_Args {
  getParams: AddExternalTourForModelParams;
  postData: UserPropertyExternalTourAddForModelRequestWebDto;
}

export type RentalManagerUserPropertyExternalTourWebApiHandler_addExternalTourForModel_Options = UseMutationOptions<
  UserPropertyExternalTourAddForModelResponseWebDto,
  unknown,
  RentalManagerUserPropertyExternalTourWebApiHandler_addExternalTourForModel_Args
>;

/**
 * Associate an external tour to a unit/floor plan
 */
export const useRentalManagerUserPropertyExternalTourWebApiHandler_addExternalTourForModel = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyExternalTourWebApiHandler_addExternalTourForModel_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyExternalTourWebApiHandler_addExternalTourForModel_Args) =>
      RentalManagerUserPropertyExternalTourWebApiHandler_addExternalTourForModel(
        args.getParams,
        args.postData,
        httpClient,
      ),
  });
};

export interface RentalManagerUserPropertyExternalTourWebApiHandler_removeExternalTourFromListing_Args {
  getParams: RemoveExternalTourFromListingParams;
  postData: UserPropertyExternalTourRemoveFromListingRequestWebDto;
}

export type RentalManagerUserPropertyExternalTourWebApiHandler_removeExternalTourFromListing_Options =
  UseMutationOptions<
    void,
    unknown,
    RentalManagerUserPropertyExternalTourWebApiHandler_removeExternalTourFromListing_Args
  >;

/**
 * Remove an external tour from a building/listing
 */
export const useRentalManagerUserPropertyExternalTourWebApiHandler_removeExternalTourFromListing = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyExternalTourWebApiHandler_removeExternalTourFromListing_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyExternalTourWebApiHandler_removeExternalTourFromListing_Args) =>
      RentalManagerUserPropertyExternalTourWebApiHandler_removeExternalTourFromListing(
        args.getParams,
        args.postData,
        httpClient,
      ),
  });
};

export interface RentalManagerUserPropertyExternalTourWebApiHandler_removeExternalTourFromModel_Args {
  getParams: RemoveExternalTourFromModelParams;
  postData: UserPropertyExternalTourRemoveFromModelRequestWebDto;
}

export type RentalManagerUserPropertyExternalTourWebApiHandler_removeExternalTourFromModel_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyExternalTourWebApiHandler_removeExternalTourFromModel_Args
>;

/**
 * Remove an external tour from a unit/floor plan
 */
export const useRentalManagerUserPropertyExternalTourWebApiHandler_removeExternalTourFromModel = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyExternalTourWebApiHandler_removeExternalTourFromModel_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyExternalTourWebApiHandler_removeExternalTourFromModel_Args) =>
      RentalManagerUserPropertyExternalTourWebApiHandler_removeExternalTourFromModel(
        args.getParams,
        args.postData,
        httpClient,
      ),
  });
};
